export const BCR_ACTION_CODE = { APPROVE: "A", REJECT: "R" };

export const MAX_VISIBLE_MULTIPLE_MATCHES = 5;

export const FI_KEYS = ["cibc", "bmo", "bns"];

export const FI_SHORT_NAME_TO_KEY = { BMO: "bmo", BNS: "bns", CIBC: "cibc" };

export const getOtherFiKeys = (incomingFiKey) => {
  const otherFiKeys = FI_KEYS.filter((fiKey) => fiKey !== incomingFiKey);
  return otherFiKeys.sort((a, b) => {
    if (a === "bmo") return -1;
    if (b === "bmo") return 1;
    return 0;
  });
};

export const CROSS_REFERENCE_ATTRIBUTES = [
  {
    suffix: "RecipientCcin",
    incomingField: "recipientCcin",
    labelKey: "erps.billermanagement.crossreference.profile.ccin",
    matchFlag: "isCcinMatch",
  },
  {
    suffix: "CreditorAccountNumber",
    incomingField: "creditorAccountNumber",
    labelKey: "erps.billermanagement.crossreference.profile.creditAccountNumber",
    matchFlag: "isCreditAccountMatch",
  },
  {
    suffix: "CreditorTransitNumber",
    incomingField: "creditorTransitNumber",
    labelKey: "erps.billermanagement.crossreference.profile.creditTransitNumber",
    matchFlag: "isCreditTransitMatch",
  },
  {
    suffix: "CreditorFiNumber",
    incomingField: "creditorFiNumber",
    labelKey: "erps.billermanagement.crossreference.profile.creditFiNumber",
    matchFlag: "isCreditFiMatch",
  },
];

export const INCOMING_PROFILE_ATTRIBUTES = [
  { field: "billerName", labelKey: "erps.billermanagement.label.billerName" },
  { field: "recipientCcin", labelKey: "erps.billermanagement.crossreference.profile.ccin" },
  { field: "creditorAccountNumber", labelKey: "erps.billermanagement.crossreference.profile.creditAccountNumber" },
  { field: "creditorTransitNumber", labelKey: "erps.billermanagement.crossreference.profile.creditTransitNumber" },
  { field: "creditorFiNumber", labelKey: "erps.billermanagement.crossreference.profile.creditFiNumber" },
];

export const isMatch = (value) => value === "Y" || value === "true" || value === true;

export const hasBillerId = (billerId) => billerId !== null && billerId !== undefined && billerId !== "";

export const getExistingSameFiBillerId = (bcrDto, incomingFiKey) => {
  return bcrDto?.[`${incomingFiKey}BillerId`];
};

export const normalizeComparableValue = (value) => {
  if (value === null || value === undefined) {
    return "";
  }
  return String(value).trim();
};

export const areAttributeValuesEqual = (leftValue, rightValue) =>
  normalizeComparableValue(leftValue) === normalizeComparableValue(rightValue);
